"use client"

import { AnimatePresence, motion } from "framer-motion"
import { WifiOff } from "lucide-react"
import { useEffect, useState } from "react"

export function OfflineIndicator() {
    const [isOffline, setIsOffline] = useState(false)

    useEffect(() => {
        const handleOnline = () => setIsOffline(false)
        const handleOffline = () => setIsOffline(true)

        // Initial check
        if (typeof window !== "undefined") {
            setIsOffline(!navigator.onLine)
        }

        window.addEventListener("online", handleOnline)
        window.addEventListener("offline", handleOffline)

        return () => {
            window.removeEventListener("online", handleOnline)
            window.removeEventListener("offline", handleOffline)
        }
    }, [])

    return (
        <AnimatePresence>
            {isOffline && (
                <motion.div
                    initial={{ y: -100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -100, opacity: 0 }}
                    className="fixed top-0 left-0 right-0 z-[60] flex justify-center pt-2 pointer-events-none"
                >
                    <div className="bg-red-500/90 backdrop-blur-md text-white px-4 py-1.5 rounded-full flex items-center gap-2 shadow-lg text-xs font-medium">
                        <WifiOff size={14} />
                        <span>You are offline</span>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}
